import { render, staticRenderFns } from "./audioModal.vue?vue&type=template&id=48d36050&scoped=true&"
import script from "./audioModal.vue?vue&type=script&lang=js&"
export * from "./audioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d36050",
  null
  
)

export default component.exports